import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3aacfd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "type"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1"} }, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "fa fa-edit"
}
const _hoisted_4 = {
  key: 2,
  class: "scope"
}
const _hoisted_5 = {
  key: 0,
  class: "type"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1"} }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "fa fa-edit ms-2"
}
const _hoisted_8 = {
  key: 2,
  class: "modal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_9 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = { class: "modal-header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Select variable", -1))
const _hoisted_13 = { class: "modal-body" }
const _hoisted_14 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_15 = { class: "form-check form-check-inline" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "write-mode-select"
}, "Select existing variable", -1))
const _hoisted_17 = { class: "form-check form-check-inline" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "write-mode-input"
}, "Create new variable", -1))
const _hoisted_19 = {
  key: 1,
  class: "form-group"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "select-variable" }, "Select available variable:", -1))
const _hoisted_21 = {
  key: 2,
  class: "form-group"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "input-variable-name" }, "Variable name:", -1))
const _hoisted_23 = {
  key: 3,
  class: "form-group"
}
const _hoisted_24 = {
  key: 0,
  for: "select-type"
}
const _hoisted_25 = {
  key: 1,
  for: "select-type"
}
const _hoisted_26 = {
  key: 4,
  class: "form-group"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "select-type" }, "JSON Schema:", -1))
const _hoisted_28 = {
  key: 5,
  class: "form-group"
}
const _hoisted_29 = {
  key: 0,
  for: "select-scope"
}
const _hoisted_30 = {
  key: 1,
  for: "select-scope"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "stack", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "context", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "flow", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "group", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "global", -1))
const _hoisted_36 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.mode === 'write')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-dark w-100 d-flex flex-row align-items-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startEdit()))
        }, [
          (_ctx.currentval.type)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.currentval.type) + " : ", 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.currentval && _ctx.currentval.name ? _ctx.currentval.name : '') + " ", 1),
          _hoisted_2,
          (!_ctx.currentval || !_ctx.currentval.name)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.currentval && _ctx.currentval.scope)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.currentval && _ctx.currentval.scope ? _ctx.currentval.scope : ''), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.mode === 'read')
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn-dark w-100 d-flex flex-row align-items-center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startEdit()))
        }, [
          (_ctx.currentval.type)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.currentval.type) + " : ", 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.currentval && _ctx.currentval.name ? _ctx.currentval.name : '') + " ", 1),
          _hoisted_6,
          (!_ctx.currentval || !_ctx.currentval.name)
            ? (_openBlock(), _createElementBlock("i", _hoisted_7))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.editval !== false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editval = false))
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.mode === 'write')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          name: "inlineRadioOptions",
                          id: "write-mode-select",
                          value: "select",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.writemode) = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.writemode]
                        ]),
                        _hoisted_16
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          name: "inlineRadioOptions",
                          id: "write-mode-input",
                          value: "input",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.writemode) = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.writemode]
                        ]),
                        _hoisted_18
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mode === 'read' || _ctx.writemode === 'select')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select select-variable",
                        size: "5",
                        id: "select-variable",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editval.name) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vars, (variable, idx) => {
                          return (_openBlock(), _createElementBlock("option", { key: idx }, _toDisplayString(variable.name), 1))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.editval.name]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mode === 'write' && _ctx.writemode === 'input')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "input-variable-name",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editval.name) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.editval.name]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mode === 'write' && _ctx._typesallowed.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_ctx.writemode === 'input')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_24, "Type:"))
                        : (_openBlock(), _createElementBlock("label", _hoisted_25, "Convert to type:")),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        id: "select-type",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editval.type) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._typesallowed, (type, idx) => {
                          return (_openBlock(), _createElementBlock("option", { key: idx }, _toDisplayString(type), 1))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.editval.type]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mode === 'write' && _ctx.editval.type == 'object')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        id: "select-schema",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editval.meta.schema) = $event))
                      }, "\n                            ", 512), [
                        [_vModelText, _ctx.editval.meta.schema]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.advmode && _ctx.mode === 'write')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_ctx.writemode === 'input')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_29, "Scope:"))
                        : (_openBlock(), _createElementBlock("label", _hoisted_30, "Convert scope:")),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        id: "select-scope",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editval.scope) = $event))
                      }, _hoisted_36, 512), [
                        [_vModelSelect, _ctx.editval.scope]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", null, [
                  (!_ctx.advmode && _ctx.mode === 'write')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-outline-light float-left",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.advmode = true))
                      }, " Change scope "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light",
                    "data-dismiss": "modal",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editval = false))
                  }, " Cancel "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
                  }, "OK")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}